import React, { useCallback, useEffect, memo, useState } from "react";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import {
  Paper,
  Button,
  Menu,
  MenuItem,
  Stack,
  AppBar,
  IconButton,
  Typography,
  Avatar,
  Box,
  ButtonBase,
} from "@mui/material";
import {
  blue,
  pink,
  orange,
  purple,
  yellow,
  green,
  grey,
  red,
  lightBlue,
  brown,
} from "@mui/material/colors";
import HighLighter from "react-highlight-words";
import { Body2 } from "./tipografia";
import Logo from "../imagens/logo_vermelha.svg";
import LogoBranca from "../imagens/logo_branca.svg";
import ImagemPintura from "../imagens/pintura.png";

import Icone from "./icone";
//
import { useDispatch, useSelector } from "react-redux";
import { getDadosUsuario, usuarioSetCorFavorita } from "../redux/actions";

//
const fnUsuario = (state) => state?.usuario;

// Dicionario com os icones que devem ser atribuidos a cada familia
export const ICONES = {
  Administração: "Build",
  Voucher: "CardGiftcard",
};

const sxStyle = {
  display: "flex",
  justifyContent: "space-between",
  height: "100%",
  alignItems: "center",
  borderRadius: "30px 0px 0px",
  px: 2,
};

const Header = ({ darkMode, handleDarkMode, isMobile, menuSPA }) => {
  // Historico para navegacao no react-router-dom
  const history = useHistory();
  const dispatch = useDispatch();
  const usuario = useSelector(fnUsuario);

  const menu = useSelector((state) => state?.usuario?.menus);

  //
  useEffect(() => {
    dispatch(getDadosUsuario());
  }, [dispatch]);

  const [exibir, setExibir] = useState(null);
  // Para exibir o menu (icone que quando clicado exibe o menu)
  const exibirSubMenu = (evt) => {
    setExibir(evt.currentTarget);
  };
  // Ocultar o menu
  const ocultarSubMenu = () => {
    setExibir(null);
  };
  // Cria uma lista de menus
  const listaMenus = [];

  _.forEach(_.keys(menu), (kFamilia) => {
    _.forEach(menu[kFamilia], (arr) => {
      listaMenus.push(arr);
    });
  });

  // Se tiver menos que 9 menus pode exibir os icones
  //const exibirIcones = menu ? Object.keys(menu)?.length < 10 : false;
  const exibirIcones = false;
  //
  const subMenu = [
    {
      titulo: "Configuraçoes do usuario",
      texto: "Configurações",
      icone: <Icone icone="Build" />,
      fn: () => {
        history.push("/configuracoes");
      },
      desabilitado: false,
    },
    {
      titulo: "Sair do App",
      texto: "Sair",
      icone: <Icone icone="Logout" />,
      fn: () => {
        window.location.href = "/logout";
      },
      desabilitado: false,
    },
  ];

  return (
    <AppBar
      position="sticky"
      variant="elevation"
      sx={{ width: "100vw", overflowX: "auto", height: 56 }}
      color="primary"
    >
      <Stack
        sx={{ height: "100%" }}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Stack flex={4} sx={{ mx: 0.5 }} direction="row">
          {!isMobile && (
            <>
              {menu &&
                Object.keys(menu).map((key, idx) => (
                  <MenuItemDaLista
                    menuSPA={menuSPA}
                    item={key}
                    lista={menu[key]}
                    key={idx}
                    exibirIcones={exibirIcones}
                  />
                ))}
            </>
          )}
        </Stack>
        <Paper sx={sxStyle}>
          <img
            alt="Logo Empresa"
            src={darkMode ? LogoBranca : Logo}
            height={24}
          />
          <PainelCores />
          {usuario?.avatar && (
            <Avatar
              title={`Olá ${usuario?.nome}`}
              src={usuario?.avatar["64x64"]}
              sx={{ ml: 0.5, width: 32, height: 32 }}
              alt={_.toUpper(usuario?.nome)}
            />
          )}
          <IconButton
            title="Alterar entre modos claro e escuro"
            sx={{ mx: 0.5 }}
            onClick={handleDarkMode}
          >
            {darkMode ? (
              <Icone icone="DarkMode" />
            ) : (
              <Icone icone="LightMode" />
            )}
          </IconButton>
          <IconButton onClick={exibirSubMenu}>
            <Icone icone="MoreVert" />
          </IconButton>
        </Paper>
      </Stack>
      <Menu
        variant="selectedMenu"
        open={Boolean(exibir)}
        onClose={ocultarSubMenu}
        anchorEl={exibir}
      >
        {subMenu?.map((ele, idx) => (
          <MenuItem disabled={ele.desabilitado} key={idx} onClick={ele.fn}>
            {ele.icone}
            <Typography onClick={ocultarSubMenu}>{ele.texto}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </AppBar>
  );
};

const MenuItemDaLista = memo(({ exibirIcones, item, lista, menuSPA }) => {
  const [exibir, setExibir] = useState(null);
  // Para exibir o menu (icone que quando clicado exibe o menu)
  const exibirSubMenu = useCallback(
    (evt) => setExibir(evt.currentTarget),
    [setExibir]
  );
  // Ocultar o menu
  const ocultarSubMenu = useCallback(() => setExibir(null), [setExibir]);

  return (
    <>
      <Button
        title={item}
        size="small"
        startIcon={
          exibirIcones && (
            <Icone
              icone={ICONES[item]}
              sx={{ color: (theme) => theme.palette.primary.contrastText }}
            />
          )
        }
        sx={{
          // mx: 0.1,
          fontSize: "80%",
          fontWeight: "bold",
          color: (theme) => theme.palette.primary.contrastText,
          textTransform: "none",
        }}
        onClick={exibirSubMenu}
      >
        {item}
      </Button>

      <Menu
        variant="selectedMenu"
        open={Boolean(exibir)}
        onClose={ocultarSubMenu}
        anchorEl={exibir}
      >
        {lista?.map((ele, idx) => (
          <MenuItemRota
            key={idx}
            menuSPA={menuSPA}
            rota={ele[0]}
            icone={ele[2]}
            nome={ele[1]}
            isDivider={idx < lista.length - 1}
            ocultarSubMenu={ocultarSubMenu}
          />
        ))}
      </Menu>
    </>
  );
});
//
const MenuItemRota = memo(
  ({ filtro, isDivider, ocultarSubMenu, rota, icone, nome, menuSPA }) => {
    const history = useHistory();
    // Funcao de callback para acessar o menu
    const fnMenu = useCallback(() => {
      ocultarSubMenu();
      if (menuSPA.includes(rota)) {
        history.push(rota);
      } else {
        window.location.href = rota;
      }
    }, [rota, menuSPA, history, ocultarSubMenu]);

    return (
      <MenuItem divider={isDivider} onClick={fnMenu}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Icone icone={icone} />
          <HighLighter
            highlightClassName="bg-yellow"
            textToHighlight={nome}
            searchWords={[filtro]}
          />
          {/* <Typography variant="body2">{nome}</Typography> */}
        </Stack>
      </MenuItem>
    );
  }
);
//
export const PainelCores = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  //
  const alterarCor = useCallback(
    (cor) => {
      dispatch(usuarioSetCorFavorita(cor));
      setAnchorEl(null);
    },
    [dispatch]
  );

  const opcoes = [
    {
      titulo: "Azul",
      cor: blue[500],
      onClick: alterarCor,
      title: "Altere a cor para Azul",
    },
    {
      titulo: "Azul Claro",
      cor: lightBlue[300],
      onClick: alterarCor,
      title: "Altere a cor para Azul Claro",
    },
    {
      titulo: "Amarelo",
      cor: yellow[500],
      onClick: alterarCor,
      title: "Altere a cor para Amarelo",
    },
    {
      titulo: "Verde",
      cor: green[500],
      onClick: alterarCor,
      title: "Altere a cor para Verde",
    },
    {
      titulo: "Cinza",
      cor: grey[500],
      onClick: alterarCor,
      title: "Altere a cor para Cinza",
    },
    {
      titulo: "Roxo",
      cor: purple[500],
      onClick: alterarCor,
      title: "Altere a cor para Roxo",
    },
    {
      titulo: "Vermelho",
      cor: red[800],
      onClick: alterarCor,
      title: "Altere a cor para Vermelho",
    },
    {
      titulo: "Rosa",
      cor: pink[500],
      onClick: alterarCor,
      title: "Altere a cor para Rosa",
    },
    {
      titulo: "Laranja",
      cor: orange[500],
      onClick: alterarCor,
      title: "Altere a cor para Laranja",
    },
    {
      titulo: "Marrom",
      cor: brown[500],
      onClick: alterarCor,
      title: "Altere a cor para Marrom",
    },
    {
      titulo: "Preto",
      cor: grey[900],
      onClick: alterarCor,
      title: "Altere a cor para Preto",
    },
  ];

  const fnCores = (e) => {
    setAnchorEl(e.currentTarget);
  };
  // Fechar o menu
  const fnFecharMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ButtonBase title="Altere o schema de cores do sistema" onClick={fnCores}>
        <img height={24} src={ImagemPintura} alt="Icone pintura" />
      </ButtonBase>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={fnFecharMenu}>
        {opcoes.map((ele, idx) => (
          <MenuItem key={idx} onClick={() => ele.onClick(ele.cor)}>
            <Stack direction="row" spacing={1}>
              <Box
                sx={{
                  borderRadius: 16,
                  backgroundColor: ele.cor,
                  height: 16,
                  width: 16,
                }}
              />
              <Body2>{ele.titulo}</Body2>
            </Stack>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default memo(Header);
